import React from 'react';
import './styles.scss';

/**
 * @param left Content to be displayed in the left section of the header component
 * @param right Content to be displayed in the right section of the header component
 */
export interface IHeaderProps {
	left?: JSX.Element;
	right?: JSX.Element;
	/** Image to load in the middle section of the header */
	logo: JSX.Element;
}

/**
 * ## Header
 * @example <Header right={<p> Content right </p>} left={<p> Content left </p>} />
 * @returns Standard Naviair header component.
 */
export const Header: React.FC<IHeaderProps> = (props) => {
	return (
		<>
			<div className={'header'}>
				<div className={'section left'}>{props.left}</div>
				<div className={'section center'}>
					<div className={'logo'}>{props.logo}</div>
				</div>
				<div className={'section right'}>{props.right}</div>
			</div>
		</>
	);
};
